import { CardContent, Card, CardHeader, CardTitle } from '../ui/card';
import { toast } from 'sonner';
import { getDiffValues } from '@/lib/utils';
import { useCurrentClub } from '@/hooks/use-current-club';
import { clubApi } from '@repo/api-client';
import { useForm } from '@repo/ui/hooks/use-form';
import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';

export function ContactInfo() {
  const club = useCurrentClub();
  const { ref, errors, values } = useForm({
    initialValues: club,
    onSubmit: async () => {
      const diffValues = getDiffValues(club, values);
      await clubApi.update(club.id, diffValues as Partial<Club>);
      toast.success('Información de contacto actualizada correctamente');
    },
  });
  return (
    <Card>
      <CardHeader>
        <CardTitle>Información de Contacto</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <form ref={ref} className="flex flex-col gap-4">
          <Input
            label="Nombre del Club"
            name="name"
            errors={errors}
            required
            minLength={3}
            maxLength={30}
            placeholder="Mi Club"
          />
          <Input
            label="Teléfono"
            name="phoneNumber"
            errors={errors}
            required
            minLength={9}
            maxLength={9}
            inputMode="numeric"
            pattern="^09\d{7}$"
            placeholder="091234567"
          />
          <Input
            label="Email"
            name="email"
            errors={errors}
            minLength={3}
            maxLength={255}
            type="email"
            placeholder="email@miclub.com"
          />
          <Input
            label="Sitio Web"
            name="website"
            errors={errors}
            minLength={3}
            maxLength={255}
            placeholder="https://www.miclub.com"
            pattern="^https?:\/\/[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9-_/]*)?$"
            type="url"
          />
          <Input
            label="Horario"
            name="openingHours"
            errors={errors}
            required
            minLength={3}
            maxLength={255}
            placeholder="Lunes a Viernes: 9:00 - 22:00, Sábados y Domingos: 8:00 - 23:00"
            type="text"
          />
          <Button type="submit">Guardar</Button>
        </form>
      </CardContent>
    </Card>
  );
}
